<template>

  <div slot="no-body" class="tabs-container px-6 pt-6">

    <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
      <vs-tab label="Administradores" icon-pack="feather" icon="icon-user">
        <div class="tab-text">
          <user-table :profile_type="'admin'" @updateSearchQuery="updateSearchQuery"/>
        </div>
      </vs-tab>
      <!-- TODO - Feature suspended in march 2025, waiting for product decision to continue... -->
      <!-- <vs-tab label="Acudientes" icon-pack="feather" icon="icon-user" @click="searchQuery = ''">
        <div class="tab-text">
          <user-table :profile_type="'parents'" @updateSearchQuery="updateSearchQuery"/>
        </div>
      </vs-tab> -->
    </vs-tabs>

  </div>

</template>

<script>

import UserTable from './UserTable.vue';

export default {
    components: {
      UserTable,
    },
    data() {
    return {
      activeTab: 0,
      searchQuery: ""
    }
    },
    methods: {
      updateSearchQuery(q) {
        this.searchQuery = q
        this.activeTab = 1
      }
    },
    watch: {
      activeTab(newTab) {
        if (parseInt(this.$route.query.tab) !== newTab) this.$router.push({ query: { tab: newTab } });
      },
    },
    created() {
      const tab = this.$route.query.tab;
      if (tab)
        this.activeTab = parseInt(tab);
    },
}

</script>

<style lang="scss">
  #page-user-list {
    .user-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
</style>
